import { create } from 'zustand';

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'info';
  message: string;
}

interface ToastState {
  toasts: Toast[];
  add: (type: Toast['type'], message: string) => void;
  dismiss: (id: string) => void;
}

let counter = 0;

export const useToastStore = create<ToastState>(set => ({
  toasts: [],

  add: (type, message) => {
    const id = String(++counter);
    set(s => ({ toasts: [...s.toasts, { id, type, message }] }));
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
    }, 4_000);
  },

  dismiss: id => {
    set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
  },
}));

// Convenience helpers
export const toast = {
  success: (msg: string) => useToastStore.getState().add('success', msg),
  error: (msg: string) => useToastStore.getState().add('error', msg),
  info: (msg: string) => useToastStore.getState().add('info', msg),
};
